const de = {
  system: {
    total: "Insgesamt",
    rm: "entfernen",
    desc: "Keine Daten",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    ondel_address_title:
      "Bist du sicher, dass du diese Adresse löschen möchtest?",
    rules_message: "Bitte eingeben",
    message_success: "Erfolg",
    message_warning: "scheitern",
    myorder: "Meine Bestellung",
    changePassword: "Passwort ändern",
    logout: "Abmelden vom Login",
    code: "Bestätigungs-Code",
    yes: "JA",
    no: "NEIN",
    rm_message: 'Durch diesen Vorgang wird der Datensatz gelöscht. Möchten Sie fortfahren?',
    rm_title: 'Warnen',
    rm_ok: 'Sicher',
    rm_cancel: 'Stornieren',
    language: 'Sprache',
    signIn: 'Anmelden',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Bestätigen',
    noOrder: 'Noch keine Bestellung',
    normalMember: 'Standardkunde'
  },
  home: {
    title: "Unsere Bestseller",
    memberCoupon: {
      title: "Neukunden-Angebot",
      desc: "Registrieren und 10% Rabatt auf die erste Bestellung sichern",
      action: "Jetzt registrieren",
      shopAction: "Zum Shop",
    },
    tit0: {
      title: "Jetzt hier kostenlos Verfugbarkeit prufen",
    },
    tit1: {
      title: "Maßgeschneiderte Transformatorlösungen bis 400 kV",
      text: "Ob Verteiltransformator, Leistungstransformator oder Sonderlösung: Wir bieten maßgeschneiderte Transformatoren für Mittel- und Hochspannungsanwendungen nach Ihren Netzanforderungen.",
      button: "Entdecken Sie Transformer-Produkte",
    },
    tit2: {
      title: "Optimierte Lösungen für Energieversorger und Großprojekte",
      text: "Unsere Produktionsstätten in China ermöglichen eine hohe Ausbringung – zum Beispiel bis zu 1.000 Mittelspannungstransformatoren pro Monat. In Kombination mit einer gut organisierten Logistik bieten wir wettbewerbsfähige Lieferzeiten.",
      button: "Unsere Wahl",
    },
    wsc_tit1: "Warum Sie uns wählen sollten",
    wsc_tit2: "Unsere Kooperationspartner",
    wsc_tit3: "Alltag mit erneuerbarer Energie",
    wsc_tit4: "Unternehmensupdates zum Teilen mit Ihnen",
    wsc_tit5: "Mehr",
    wsc_sub1: "Unsere Produkte erfüllen höchste internationale Qualitäts- und Sicherheitsstandards",
    wsc_sub2: "Vertrauen Sie auf unsere starken Partnerschaften mit führenden Unternehmen der Energiebranche",
    wsc_sub3: "Bleiben Sie informiert über die neuesten Entwicklungen und Projekte",
    services_title: "Unsere Dienstleistungen",
    services_sub: "Maßgeschneiderte Lösungen für Ihre Energieprojekte",
    readMore: "Weiterlesen",
    learnMore: "Mehr erfahren",
    box1: "Schaltanlagen",
    box1_desc: "Effiziente und SF₆-freie Hochspannungsschaltanlagen.",
    box2: "Transformator",
    box2_desc: "Leistungsstarke Transformatoren für Hochspannungsnetze.",
    box3: "Mittelspannungskabel",
    box3_desc: "Zuverlässige Verbindungslösungen für Energieverteilung.",
  },
  banner: {
    title: "Unterstützung der erneuerbaren Energie",
  },
  footer: {
    p1: "Beratungshotline：",
    p2: "Abholung", // Kontakt
    p3: "Deutschland",
    p5: 'Ansichten',
    avis1: "Kostenloser Transport",
    avis2: "Zahlungsmöglichkeiten",
    search: {
      tit: "Jetzt abonnieren und Kontakt aufnehmen!",
      button: "Abonnement",
      t1: "Ich stimme den",
      t2: " Nutzungsbedingungen ",
      t3: "und",
      t4: "Datenschutz zu",
    },
    navList: {
      name1: "über uns",
      children1: {
        name1: "Teamunterstützung",
      },
      name2: "Unterstützung",
      children2: {
        name2: "Unsere ökologische Charta",
      },
    },
  },
  pay: {
    item1: "Startseite",
    item2: "Produktcenter",
    item3: "Produktinformation",
    item4: "Vergütung",
    label1: {
      title: "Kontaktinformationen",
      text: "Sie haben bereits ein Konto?",
      el: "Anmeldung",
      input: "Bitte wählen Sie eine Adresse aus",
      tip: "Geben sie hier ihre adresse ein.",
    },
    label2: {
      title: "Lieferanschrift",
      input1: "Name",
      input2: "Andere Adressinformationen",
      input3: "Postleitzahl",
      input4: "Stadt",
      input5: "Kontakt",
    },
    info: {
      pro_info: "Produktinformation",
      type1: "DC Trans Logistik & Trade GmbH",
      type2: "Eisenstrasse 30, 65428 Rüsselsheim",
      type3: "Postbank Ndl der Deutsche Bank",
      span1: "Kostenloser Versand",
      span2: "Lebenslanger Service",
      span3: "Keine Fragen gestellt.Herstellergarantie",
    },
    button: "Bezahlen",
    products: {
      message_error: "Parameterfehler!",
    },
    validate: {
      message1: "Bitte wählen sie die abstelladresse aus",
      message2: "Bitte wählen sie die anschrift aus",
      message3:
        "Bitte stimmen sie zu und halten sie sich an die beschäftigungsbedingungen",
    },
    addOrder: {
      message_success: "Erfolgreich bestellt",
      message_warning: "Bestellung fehlgeschlagen",
    },
    notice:
      "Achtung: bitte überprüfen sie, ob sie ihren namen an die klingel kleben und ob sie verboten sind Oder an jemanden weiterreichen, sonst kann sie nicht ankommen. Um das paket sicher zu packen, bitte sortieren sie alles, was zerbrechlich ist.",
    transfer: {
      text1:
        "Bitte überweisen sie den betrag der rechnungen in unser bankkonto. Sie erhalten die bestätigung unserer mailinterschrift, die die bankdaten und ihre bestellnummer enthält",
      text2: "Geldsumme",
      text3: "Name des kontoverwalters",
      text4: "Die details, bitte",
      text5: "Bank - konto",
      text6: "Die adresse des empfängers",
      text7: "Name der bank",
      text8: "Ich bin damit einverstanden und werde es befolgen",
      text9: "nutzungsbedingungen",
    },
    result: {
      text1:
        "Ihre Zahlung wurde erfolgreich abgeschlossen. Ihre Bestellung wird derzeit bearbeitet und für den Versand vorbereitet.",
      text2: "Auftragsnummer",
      text3: "Zahlungsmethode",
      text4: "Das sind bankkonten",
      text5: "Zahlungen",
      fail_text: 'Die Zahlung ist fehlgeschlagen. Bitte versuchen Sie es erneut oder wählen Sie eine andere Zahlungsmethode.',
      cancle_text: 'Die Zahlung wurde abgebrochen. Ihre Bestellung wurde nicht abgeschlossen.',
      loading_text: 'Zahlung wird bestätigt, bitte warten...',
    },
    button2: "Weiter zur Startseite",
    button3: "Meine Betellung",
    type: "transportart",
    pay_info:
      "DHL Global Express Deutschland Lieferung nach Hause /Paket Shop über 39 Euro kostenlose Lieferung",
    pay_info_days: "2-4 Arbeitstage",
    pay_way: "Zahlungsweg",
    pay_type: "Zahlung per Banküberweisung",
    eur: "(Ab. 3999 €)",
    pay_desc:
      "Indem Sie Ihr Bankkonto hinzufügen, autorisieren Sie Amazon, Anweisungen zu senden Ihr Konto belasten. Sie ermächtigen auch Ihre Bank,belasten Sie Ihr Konto gemäß diesen Anweisungen. Sie können einen Rückerstattung innerhalb von 8 Wochen nach dem Abbuchungsdatum. Die Bedingungen, denen Sie zugestimmt haben Ihre Bank beantragen.",
    pay_save: "Speichern für zukünftige Einkäufe",
    pay_info_pay:
      "Ihre Zahlungsinformationen sind verschlüsselt und sicher.< br />Das Speichern Ihrer Zahlungsmethode für zukünftige Einkäufe wird Ihnen helfen Check out schneller.",
    pay_more: "Erfahren Sie mehr",
    add_bank: "Bankkonto hinzufügen",
  },
  pay2: {
    freeShipping: 'Kostenloser Versand',
    text1: 'Kontaktdaten',
    text2: 'Lieferart',
    text3: 'Zahlungsart',
    text4: 'Bestellabschluss',
    text5: "Lieferungsadresse",
    text6: "Rechnungsadresse",
    text7: "Bearbeiten",
    text8: "Andere Lieferadresse",
    text9: "Lieferzeit 2-3 Werktage",
    text10: "Lieferung mit:",
    text11: 'Du hast noch keine Lieferadresse hinterlegt',
    text12: 'Abholstation',
    text13: 'Geh zur logistikstation',
    btn1: "Weiter",
    btn2: "Weiter",
    btn3: 'Lieferadresse hinzufügen',
    btn4: 'Lieferadresse wählen',
    btn5: 'Jetzt kaufen',
    tit1: 'Meine Daten',
    tit2: 'Deine Rechnungsadresse',
    tit3: 'Wähle eine Lieferadresse?',
    tit4: 'Lieferadresse',
    tit5: 'Zahlungsart auswählen?',
    tit6: 'Warenkorb',
    option1: 'PayPal',
    option2: 'Kreditkarte',
    msg1: 'Mit PayPal bezahlst Du bequem und sicher. Sobald Du ein PayPal-Konto hast, bezahlst Du nur noch mit der Eingabe von E-Mail-Adresse und Passwort. Diese erfolgt nach Abschluss der Bestellung.',
    msg2: 'Der offene Rechnungsbetrag wird bei Versand Deines Einkaufs von Deinem Kreditkartenkonto abgebucht. Die Eingabe Deiner Kreditkartendaten erfolgt nach Abschluss der Bestellung.',
    msg3: 'Inklusive mehrwertsteuer.',
    text22: 'Selbstabholung',
    text23: 'Holen Sie Ihre Bestellung direkt bei uns ab',
    submitOrder: 'Möchten Sie diesen Auftrag abschließen ?'
  },
  address: {
    txt: "Lieferadressen",
    p: "Hinweis: Beim Abschließen der Bestellung können Lieferadressen bearbeitet oder hinzugefügt werden.",
    button: "Fügen Sie eine neue Adresse hinzu",
    tag: "Standard",
    onEdit: "Bearbeiten",
    form: {
      name: "Vorname",
      phone: "Telefonnummer",
      address: "Adresse",
      company: 'Hausnummer/Apt/Firmenname,C/O',
      street: 'Straße',
      number: 'Nr.',
      number_tip: 'Es gibt keine straßennummer, die durch "ersetzt wird',
      postal_code: "Postleitzahl",
      city: "Stadt",
      country: "Staat",
      checkbox: "Als Standard-Adresse festlegen",
      checkbox2: "Die adresse wird auch als rechnungsadresse verwendet",
      onSubmit: "Adresse hinzufügen",
      default: 'Standard',
    },
    rules: {
      message: "Pflichtfeld",
    },
    dialog_tiltle: "Fügen Sie eine neue Adresse hinzu",
    name: "adresse",
    shipping: "Lieferadresse",
    bill: "Rechnungsadresse",
  },
  clause: {
    onClose: "Alle ablehnen",
    acceptAll: "Alle akzeptieren",
    class1: "Wir schätzen Ihre Privatsphäre",
    class2: "Wir verwenden Cookies, um Ihr Surferlebnis zu verbessern, personalisierte Inhalte bereitzustellen und die Nutzung der Website zu analysieren. Durch Klicken auf \u201EAlle akzeptieren\u201C stimmen Sie der Verwendung von Cookies zu. Weitere Informationen finden Sie in unserer",
    class3: "",
    class4: "Cookie-Richtlinie",
    text4: "",
    class5: "Funktional",
    class6: "Cookies zur Analyse und Verbesserung der Website-Leistung und des Nutzererlebnisses.",
    class7: "Marketing",
    class8: "Cookies für personalisierte Werbung und Anzeigen auf Partnerplattformen.",
    onAccept: "Alle akzeptieren",
    class10: "Einstellungen anpassen",
    br2: "Cookie-Richtlinie",
    class11: "Impressum",
    msg1: "Cookie-Einstellungen",
    msg2: "Wählen Sie aus, welche Cookies Sie zulassen möchten.",
    msg3: "Marketing",
    msg4: "Ermöglicht personalisierte Werbung auf Partnerplattformen wie Google und sozialen Netzwerken.",
    msg5: "Funktional",
    msg6: "Ermöglicht Analyseaktivitäten zur Verbesserung der Website-Leistung und des Nutzererlebnisses.",
    msg7: "Sie können Ihre Einwilligung jederzeit über die Cookie-Einstellungen widerrufen. Ohne Auswahl werden nur erforderliche Cookies verwendet.",
    msg8: "Auswahl bestätigen",
    required: "Erforderlich",
    alwaysActive: "Immer aktiv",
  },
  order: {
    item1: "Titelseite",
    item2: "Meine Bestellung",
    tip: "Bitte laden Sie den Überweisungsbeleg hoch",
    upload1: "Überweisungsbeleg",
    remittance: "Überweisungsbescheinigung:",
    wmsInfo: "Lieferungsnummer:",
    select: "Staatliche aufträge",
    produces: 'Produktliste',
    state: {
      label1: "Nicht bezahlt",
      label2: "Bezahlt",
      label3: "Versandt",
      label4: "Abgeschlossen",
    },
    refund: {
      title: "Rueckerstattung beantragen",
      orderNo: "Bestellnummer",
      amount: "Rueckerstattungsbetrag",
      reason: "Grund der Rueckerstattung",
      reasonPlaceholder: "Grund auswaehlen oder eingeben",
      description: "Beschreibung",
      descriptionPlaceholder: "Weitere Details fuer den Haendler hinzufuegen",
      evidence: "Nachweisbild",
      upload: "Bild hochladen",
      submit: "Anfrage senden",
      reasonRequired: "Bitte waehlen Sie einen Grund aus oder geben Sie einen ein.",
      reasonMax: "Der Grund darf 255 Zeichen nicht ueberschreiten.",
      reasons: {
        productIssue: "Produktproblem",
        wrongItem: "Falscher Artikel",
        qualityProblem: "Qualitaetsproblem",
        other: "Sonstiges",
        addressWrong: "Falsche Lieferadresse",
        notAsDescribed: "Entspricht nicht der Beschreibung",
        infoWrong: "Falsche Angaben",
        reorder: "Neu bestellen",
        damaged: "Artikel beschaedigt erhalten",
        delayedOther: "Nicht rechtzeitig versendet oder sonstiger Grund",
      },
    },
  },
  product: {
    item1: "Startseite",
    item2: "Produktcenter",
    class: "SUCHE",
    info: "Registrieren Sie sich, um mehr Rabatte zu erhalten",
    label: "Internet Anschluss",
    prefixPrice: "Ab. ",
    suffixPrice: "",
    detail: {
      scrollTo1: "Bezahlen",
      scrollTo2: "Spezifikationen",
      item1: "Titelseite",
      item2: "Produktcenter",
      label: "Spezifikation",
      Menge: "Menge",
      label1: "Versandart",
      wsc_title1: "Beschreiben",
      wsc_title2: "Features",
      wsc_title3: "Technische Details",
      class1: "In den Warenkorb",
      class2: "Jeztz kaufen",
      dowload_tit: "Herunterladen",
      dowload1: "Installationsanleitung",
      dowload2: "Andere Dokumente",
      dowload3: "Handbuch",
      dowload4: "Qualitätsgarantiehandbuch",
      dowload5: "Download",
      message: "Erfolgreich hinzugefügt",
      message2:
        "Das produkt befindet sich bereits im einkaufswagen, daher muss es nicht wiederholt hinzugefügt werden",
      params: "Produktparameter",
      weight: "Gewicht",
      dimensions: "Abmessungen",
      inStock: "Auf Lager",
      outOfStock: "Nicht verfügbar",
      vat: "(brutto.)",
      downloadTitle: "Daten herunterladen",
      chooseLang: "Wählen Sie Ihre Sprache",
      global: "Global",
      fileName: "Dateiname",
      fileLanguage: "Sprache",
      fileFormat: "Format",
      fileSize: "Größe",
      fileUpdated: "Zuletzt aktualisiert",
      fileDownload: "Herunterladen",
      noDocs: "Keine Dokumente gefunden.",
    },
    checkOption: {
      label1: "Internet Anschluss",
    },
  },
  news: {
    item1: "Startseite",
    item2: "Nachricht",
    item3: 'Aktuelle Ereignisse',
    item4: 'Nachricht Detail',
    item5: 'Freigabezeit',
    text1: 'OSS · Aktuelle Ereignisse',
    text2: 'viel mehr',
    text3: 'Vorheriger Artikel',
    text4: 'Nächster Artikel'
  },
  shop: {
    item1: 'Startseite',
    item2: 'Mein Warenkorb',
    tit1: "Mein Warenkorb",
    tit2: "Artikel",
    button: "Bestellung aufgeben",
    tit3: 'Verstandkosten',
    tit4: 'rechnungsbetrag',
    tit5: 'Der zu zahlen ist',
    tit6: 'MwSt. und Versand nicht enthalten',
    summary: 'Bestellübersicht',
    subtotal: 'Zwischensumme',
    free: 'Kostenlos',
    pendingShipping: 'Wird berechnet',
    continue: 'Weiter einkaufen',
  },
  solution: {
    tit: "über uns",
    tit1: "Wir bei Oss Energie sind leidenschaftlich daran interessiert, nachhaltige EnergieOptimale Lösungenen anzubieten, die die Umwelt schützen und gleichzeitig den Bedürfnissen unserer Kunden gerecht werden. Mit einer langjährigen Erfahrung und einem engagierten Team von Experten haben wir uns zum Ziel gesetzt, die Welt zu einem grüneren und saubereren Ort zu machen.",
    tit2: "Unsere Dienstleistungen umfassen die Installation und den Betrieb von hochwertigen Solarenergieanlagen für Privat- und Geschäftskunden. Wir bieten maßgeschneiderte Optimale Lösungenen, die auf die individuellen Bedürfnisse und Anforderungen unserer Kunden zugeschnitten sind. Von der Anfangsberatung über die Planung und Installation bis hin zur regelmäßigen Wartung und Überwachung sorgen wir für eine reibungslose und effiziente Nutzung der Solarenergie.",
    tit3: "Unser Engagement für Qualität und Nachhaltigkeit ist der Kern unserer Geschäftsphilosophie. Wir arbeiten eng mit unseren Kunden zusammen, um sicherzustellen, dass ihre Solarenergieanlagen optimal funktionieren und maximalen Nutzen bieten. Wir sind stolz darauf, unseren Kunden kostengünstige Energie und langfristige Einsparungen zu ermöglichen.",
    wsc_title1: "Produkte",
    tit4: "Wir bei Oss Energie sind leidenschaftlich daran interessiert, nachhaltige EnergieOptimale Lösungenen anzubieten, die die Umwelt schützen und gleichzeitig den Bedürfnissen unserer Kunden gerecht werden. Mit einer langjährigen Erfahrung und einem engagierten Team von Experten haben wir uns zum Ziel gesetzt, die Welt zu einem grüneren und saubereren Ort zu machen.Kontaktieren Sie uns jetzt unter +49 69 71585988 oder klicken Sie auf Mehr sehen.",
    btn: "Mehr sehen",
    wsc_title2: "Unser Vorteil",
    tit5: "Tongwei Solarschindelmodule nehmen innovative Schindeltechnologie an, die stärker und schöner als traditionelle Solarmodule ist und Solarenergie auch effektiver nutzen kann und dadurch die Effizienz der Stromerzeugung verbessert",
    wsc_title3: "Optimale Lösungen",
    tit6: "Bei oss energy legen wir nicht nur Wert auf die Qualität und Leistung unserer Produkte, sondern auch auf einen hervorragenden Kundenservice. Unser erfahrenes Team installiert Ihre Anlage gemäß den Industriestandards und bietet einen umfassenden After-Sales-Service, um einen langfristigen Betrieb und Wartung zu gewährleisten. Wir stellen Ihre Bedürfnisse in den Mittelpunkt und bieten zuverlässige Optimale Lösungenen und technischen Support.",
    tit7: "Optimale Lösungen 1: Sie haben noch keine Photovoltaikanlage",
    tit8: "Wir bieten Ihnen maßgeschneiderte grüne EnergieOptimale Lösungenen mit hoher Rentabilität und langfristiger Garantie. Auf der Grundlage Ihres individuellen Stromverbrauchs erstellen wir einen wirtschaftlichen Energieplan, damit Sie schnellstmöglich Gewinne erzielen. Unsere qualitativ hochwertigen Produkte maximieren Ihre Amortisationszeit.",
    tit9: "Optimale Lösungen 2: Sie haben bereits eine Photovoltaikanlage, benötigen aber einen Speicher",
    tit10:
      "Unsere schnelle Photovoltaik-SpeicherOptimale Lösungen ermöglicht den Anschluss eines Batteriesystems ohne erneute Netzanschlussgenehmigung oder Demontage der bestehenden Anlage. Mit den Wechselrichtern der FIT-Serie erreichen Sie eine effiziente Verbindung zwischen der Batterie und Ihrer bestehenden Photovoltaikanlage. Sie sparen Zeit und erhöhen Ihren Eigenverbrauch durch die schnelle Implementierung eines effizienten Speichersystems.",
    wsc_title4: "Erfolge und Anerkennungen",
    tit11:
      "Die Photovoltaik-Module von TW Solar wurden von Bloomberg New Energy Finance als eines der zehn weltweit führenden Tier-1-Module im 4. Quartal 2022 und im 1. Quartal 2023 ausgezeichnet.",
    tit12:
      "Der SolaX Power wurde bei den UK Solar Power Portal Awards als 'Bester gewerblicher Wechselrichter', bei den Australian Intersolar Awards als 'Bestes Batterie-Energiespeichersystem' ausgezeichnet und von EUPD Research in Deutschland als 'Bester Wechselrichter' und 'Beste Batterie' in Großbritannien anerkannt.",
    item1: "Tier-1 Liste",
    item2: "Top-Wechselrichter in UK",
    item3: "Top-BESS in Au",
    item4: "Top Wechselrichter und Battery in Großbritannien und DE",
    item5: "ECS",
    wsc_title5: "Produktvorteile",
    wsc_title6: "Für Privathaushalte",
    li1: "Kapazitätsbereich: Wir spezialisieren uns auf die Bereitstellung von Photovoltaiksystemen mit einer Leistung zwischen 6 und 30 Kilowattpeak (kWp), ideal für die Energiebedürfnisse von Privathaushalten.",
    li2: "Maßgeschneiderte Optimale Lösungenen: Unsere maßgeschneiderten PhotovoltaikOptimale Lösungenen integrieren sich perfekt in individuelle Energiebedürfnisse und räumliche Gegebenheiten.",
    li3: "Effiziente Installation: Unsere Experten gewährleisten eine schnelle und unkomplizierte Installation, die sich nahtlos in das häusliche Umfeld einfügt.",
    li4: "Kosteneffektivität und Förderungen: Wir unterstützen unsere Kunden dabei, maximale finanzielle Vorteile, einschließlich Energiekosteneinsparungen und staatlicher Fördermittel, zu erzielen.",
    li5: "Einfache Wartung: Unsere wartungsarmen PV-Systeme bieten eine zuverlässige und effiziente Energieversorgung.",
    li6: "Regelkonformität: Wir garantieren die Einhaltung aller lokalen Bauvorschriften und rechtlichen Anforderungen.",
    wsc_title7: "Für Gewerbe",
    li7: "Kapazitätsbereich: Für Unternehmen bieten wir umfangreiche PV-Optimale Lösungenen bis zu einer Leistung von 2 Billionen Kilowattpeak (kWp), die für die hohen Energieanforderungen von gewerblichen und industriellen Betrieben konzipiert sind.",
    li8: "Großangelegte PV-Projekte: Unsere Anlagen sind skalierbar und können flexibel an komplexe Betriebsstrukturen angepasst werden.",
    li9: "Erweiterte Energiemanagementsysteme: Wir integrieren PV-Systeme in bestehende Energiemanagementstrukturen und bieten innovative Optimale Lösungenen für Energieerzeugung, -speicherung und -verwaltung.",
    li10: "Umfassende Beratung und Compliance: Unser erfahrenes Team navigiert durch komplexe regulatorische Landschaften, um Compliance und betriebliche Effizienz sicherzustellen.",
    li11: "Langfristige Investitionsrenditen: Wir helfen Unternehmen, langfristige finanzielle und ökologische Vorteile zu erzielen.",
    li12: "Professionelle Wartung und Überwachung: Wir bieten fortschrittliche Dienstleistungen, um die Leistung der PV-Systeme zu maximieren.",
    bTitle1: 'UNSERE HAUSHALTSPROJEKTE',
    bTitle2: 'UNSERE GEWERBEPROJEKTE',
    bTip: 'WIR MACHEN IHRE HÄUSER GRÜNER!',
    bTip2: 'WIR MACHEN IHRE GESCHÄFTE GRÜNER!'
  },
  login: {
    login_name: "Anmeldung",
    register_name: "Registrieren",
    code: "Bestätigungs-Code",
    login_tit: "Das beste Erlebnis genießen",
    tit: "Einfach einloggen und Bestellungen verfolgen, Einstellungen regulieren und exklusive Angebote genießen.",
    tit1: "Bitte geben Sie die Registrierungsinformationen ein und melden Sie sich an, um nach der Registrierung die Rabattinformationen anzuzeigen",
    tit2: "Bestehendes Konto, Passwort vergessen?",
    form: {
      name: "Name",
      namePlaceholder: "Geben Sie Ihren vollstaendigen Namen ein",
      email: "E-Mail",
      emailPlaceholder: "ihre-email@beispiel.de",
      password: "Passwort",
      passwordPlaceholder: "Geben Sie Ihr Passwort ein",
      createPasswordPlaceholder: "Erstellen Sie ein starkes Passwort",
      confirmPassword: "Passwort bestaetigen",
      confirmPasswordPlaceholder: "Passwort wiederholen",
      code: "Bestaetigungscode",
      codePlaceholder: "Code eingeben",
    },
    checkEmail: {
      tit1: "E-Mail darf nicht leer sein",
      tit2: "Bitte geben Sie Ihre E-Mail-Adresse an.",
    },
    validatePass2: {
      tit1: "Bitte geben Sie das Passwort erneut ein",
      tit2: "Die doppelt eingegebenen Passwörter sind inkonsistent!",
    },
    password: {
      message: "Das passwort hat eine länge Von 8-16 zeichen",
      tit: "Must not same as the username",
    },
    checkCode: {
      tit: "Der Verifizierungscode ist leer",
    },
    content: "Bitte geben Sie eine Kombination aus Buchstaben und Zahlen ein",
  },
  resetPwd: {
    name: "Passwort Weitersetzen",
    reset: "Weitersetzen",
    login: "Login",
    tit1: "E-Mail Bestätigen",
    tit2: "Passwort Festlegen",
    tit3: "Beenden",
    next: "Nächster",
    prev: "Vorherige",
  },
  error: {
    page: "Seite nicht vorhanden",
    return: "Weiter zur vorherigen Seite",
  },
  header: {
    menuList: {
      name1: "Top Seller",
      name2: "Über Uns",
      name3: "Energiegerätevertretung",
      name4: "Online Shop",
      name5: "Kontakt",
      children1: {
        name1: "Wohannlage",
      },
      children3: {
        name1: "Transformatoren",
        name2: "Schaltanlagen",
        name3: "Mittelspannungskabel",
      },
    },
  },
  contact: {
    title: "Nehmen Sie Kontakt mit uns auf",
    messgage1:
      "Wir sind gerne für Sie da, rufen Sie uns an oder senden Sie uns eine Nachricht. Wir freuen uns darauf, von Ihnen zu hören!",
    messgage2:
      "Ich willige ein, dass diese Website meine übermittelten Informationen speichert, sodass meine Anfrage beantwortet werden kann.",
    form: {
      title: "Senden Sie uns eine Nachricht",
      subtitle: "Füllen Sie das Formular aus und wir werden uns so schnell wie möglich bei Ihnen melden",
      label0: "Position",
      label1: "Firma",
      label2: "Vor- Nachname",
      label3: "E-Mail",
      label4: "Telefon",
      label5: "Nachricht",
      label6: "DSGVO-Einverständnis",
      placeholder0: "z.B. Projektmanager",
      placeholder1: "Ihr Firmenname",
      placeholder2: "Ihr vollständiger Name",
      placeholder3: "ihre.email@example.de",
      placeholder4: "+49 123 456 7890",
      placeholder5: "Teilen Sie uns mit, wie wir Ihnen helfen können...",
    },
    info: {
      address: "Adresse",
      phone: "Telefon",
      email: "E-Mail",
      hours: "Geschäftszeiten",
      workdays: "Montag - Freitag",
      time: "9:00 - 18:00 Uhr",
    },
    button: "Nachricht senden",
  },
  top3: {
    tit1: {
      title: 'X3 Hybrid Wechselrichter',
      text: 'Der SolaX X3 Hybrid Wechselrichter, verfügbar in 5 kW bis 15 kW Varianten, zeichnet sich durch seine Effizienz von bis zu 97,5% beim Laden und Entladen aus. Er bietet 200% Oversizing für PV-Anlagen und bis zu 110% AC-Überlastausgang. Mit Schattenverfolgungsfunktion, wirtschaftlichem Betrieb und Unterstützung für leistungsstarke Solarmodule (bis zu 150% PV-Eingang), speichert er effizient Energie von PV zu Batterie. Sicher mit IP65-Schutz und Überspannungsschutz, bietet er intelligente Technologie für schnelle Umschaltung in unter 10 Millisekunden, Kompatibilität mit Lithium-Ionen- und Blei-Säure-Batterien und schnelle Lastreaktion (0,3 Sekunden). '
    },
    tit2: {
      title: 'SMART EV CHARGER',
      text: 'Der SolaX Smart EV-Ladegerät bietet fortschrittliche Ladeoptionen für Elektrofahrzeuge. Erhältlich in drei Modellen: X1-EVC-7.2K, X3-EVC-11K und X3-EVC-22K, ermöglicht es flexible Lademöglichkeiten. Der Ladegerät ist benutzerfreundlich, mit wählbaren Steckern oder Steckdosen für leichte Installation und für den Einsatz im Innen- und Außenbereich geeignet. Es bietet intelligente Lastausgleichskontrolle und ermöglicht das Setzen von Timern zur Nutzung von Spitzen- und Tiefpreisen. Drei Lademodi stehen zur Verfügung: Green Mode, der PV-Energie nutzt, Fast Mode für maximale Ladegeschwindigkeit und ECO Mode für eine festgelegte Leistung. Die Fernüberwachung und -steuerung erfolgt über eine benutzerfreundliche App​​. '
    },
    tit3: {
      title: 'T30 Batterie',
      text: 'Die T30 Batterie von SolaX, ein Teil der Triple Power-Serie, bietet eine hochmoderne Optimale Lösungen für die Speicherung von Solarenergie. Sie ist in verschiedenen Kapazitäten von 3,3 kWh bis 17,6 kWh verfügbar und eignet sich sowohl für Niedrig- als auch Hochspannungsinstallationen. Ihre hohe Speicherkapazität ermöglicht eine langfristige Speicherung von Solarenergie, wodurch die Abhängigkeit vom Stromnetz reduziert wird. Die Batterie verwendet fortschrittliche Lithium-Eisenphosphat-Technologie für hohe Energiedichte und Langlebigkeit. Zudem ist das System modular und erweiterbar, sodass Kunden zusätzliche Batterien hinzufügen können, wenn ihr Speicherbedarf steigt. Die benutzerfreundliche Software ermöglicht einfaches Monitoring und Kontrolle des Energieverbrauchs​​. '
    }
  },
  airset: {
    breadcrumb: {
      home: 'Startseite',
      products: 'Produktzentrum',
      current: 'RM AirSeT™'
    },
    hero: {
      title: 'RM AirSeT™',
      subtitle: 'SF6-freie kompakte oder erweiterbare gasisolierte Ringkabelschaltanlagen für die sekundäre Verteilung bis 24 kV / 630 A / 20 kA'
    },
    products: {
      title: 'Produktpalette',
      subtitle: 'Drei Ausführungen für unterschiedliche Anwendungsanforderungen',
      view3d: '3D-Modell ansehen',
      p1: {
        name: 'SM AirSeT™',
        subtitle: 'Kompakte Lösung',
        desc: 'Sie eignet sich für Anwendungen im sekundären Verteilnetz, von Energieversorgungsunternehmen und erneuerbaren Energien bis hin zu industriellen und gebäudetechnischen Lösungen.',
        specs: 'bis 24 kV | 630 A | 20 kA',
        badge: 'Platzsparend'
      },
      p2: {
        name: 'RM AirSeT™',
        subtitle: 'Erweiterbare Variante',
        desc: 'Sie eignet sich für Anwendungen im sekundären Verteilnetz, von Energieversorgungsunternehmen und erneuerbaren Energien bis hin zu Geschäfts- und Industriegebäuden.',
        specs: 'bis 24 kV | 1250 A | 20 kA',
        badge: 'Empfohlen'
      },
      p3: {
        name: 'GM AirSeT™',
        subtitle: 'Intelligente Ausführung',
        desc: 'Sie eignet sich für Anwendungen im primären Verteilnetz, von Energieversorgungsunternehmen und erneuerbaren Energien bis hin zu Geschäfts- und Industriegebäuden.',
        specs: 'bis 24 kV | 1250 A | 25 kA',
        badge: 'Smart Grid'
      }
    },
    overview: {
      badge: 'SF6-Frei',
      title: 'Gasisolierte Schaltanlage für nachhaltige Energieverteilung',
      desc: 'RM AirSeT™ ist eine umweltfreundliche, SF6-freie gasisolierte Schaltanlage (GIS) von Schneider Electric. Mit reiner Luft als Isolationsmedium bietet sie eine nachhaltige Lösung für Mittelspannungs-Ringkabelnetze. Kompakt oder erweiterbar konzipiert, eignet sie sich ideal für die sekundäre Energieverteilung in urbanen und industriellen Umgebungen.',
      features: {
        f1: {
          title: '100% SF6-frei',
          desc: 'Reine Luft-Isolation, keine schädlichen Treibhausgase'
        },
        f2: {
          title: 'Kompakt & Flexibel',
          desc: 'Platzsparendes Design, erweiterbar nach Bedarf'
        },
        f3: {
          title: 'Ringkabeltechnik',
          desc: 'Zuverlässige Lösung für Sekundärverteilungsnetze'
        }
      }
    },
    model3d: {
      title: '3D-Modell ansehen',
      description: 'Erkunden Sie das RM AirSeT™ in einer interaktiven 360° Ansicht',
      button: '3D-Modell öffnen'
    },
    merkmale: {
      title: 'Vorteile',
      subtitle: 'Innovative Technologie für nachhaltige Energieverteilung',
      m1: {
        title: 'Nachhaltigkeit',
        desc: 'Reine Luft als Isolationsmedium - null Treibhausgasemissionen, GWP = 1',
        advantages: [
          'Luftisolierung + Vakuumschaltung (keine F-Gase)',
          'Null Treibhauspotenzial (keine Entsorgungskosten)'
        ]
      },
      m2: {
        title: 'Sicherheit',
        desc: 'Platzsparende Konstruktion für urbane Umgebungen und begrenzte Räume',
        advantages: [
          'IP67-Gehäuse (umgebungsbeständige Isolierung)',
          '3-Positionen-Schalter + SVI™ (giftfreie Schaltung)',
        ]
      },
      m3: {
        title: 'Zuverlässigkeit',
        desc: 'Flexibel erweiterbar nach zukünftigen Energiebedürfnissen',
        advantages: [
          '40 Jahre Qualität (5M+ installierte Einheiten)',
          'Versiegelter IP67-Tank (wartungsfrei über Lebensdauer)'
        ]
      },
      m4: {
        title: 'Flexibilität',
        desc: 'Gleiche Sicherheitsstandards wie SF6-Anlagen, vollständig getestet',
        advantages: [
          '1-4 Einheiten in 1 Gehäuse (kompakte Stellfläche)',
          'Anpassbare vorkonfigurierte Kits (2 Höhen für Schaltanlagen/Sockel)'
        ]
      },
      m5: {
        title: 'Konnektivität',
        desc: 'Langlebige Komponenten, reduzierte Betriebskosten über gesamten Lebenszyklus',
        advantages: [
          'IT/OT-Integration (Echtzeitüberwachung)',
          '3D-Modelle + DMS-Anbindung (Unterstützung vorausschauender Wartung)',
        ]
      },
      m6: {
        title: 'Digital Ready',
        desc: 'EcoStruxure™-kompatibel für intelligentes Energiemanagement und Fernüberwachung',
        advantages: [
          'EcoStruxure™ Integration',
          'IoT-Sensoren verfügbar',
        ]
      }
    },
    benefits: {
      title: 'Ihre Vorteile',
      subtitle: 'Nachhaltig, sicher und zukunftssicher',
      b1: {
        title: 'Klimaneutral',
        desc: 'Null SF6-Emissionen, GWP = 1, erfüllt F-Gas-Verordnung und Green Deal Ziele'
      },
      b2: {
        title: 'Bewährte Technologie',
        desc: 'Erprobte Luft-Isolationstechnik mit gleichem Sicherheitsniveau wie SF6-Anlagen'
      },
      b3: {
        title: 'Wartungsarm',
        desc: 'Langlebiges Design, reduzierte Betriebskosten über den gesamten Lebenszyklus'
      },
      b4: {
        title: 'Zukunftssicher',
        desc: 'Erfüllt kommende Umweltvorschriften, keine Einschränkungen bei der Nutzung'
      }
    },
    applications: {
      title: 'Einsatzgebiete',
      subtitle: 'Vielseitige Anwendungen in der Mittelspannungsverteilung',
      a1: {
        title: 'Wohn- und Gewerbegebäude',
        desc: 'Stromversorgung für Wohnkomplexe, Bürogebäude und Einkaufszentren'
      },
      a2: {
        title: 'Industrie',
        desc: 'Energieverteilung für Produktionsstätten und Fertigungsanlagen'
      },
      a3: {
        title: 'Kritische Infrastruktur',
        desc: 'Zuverlässige Versorgung für Krankenhäuser, Rechenzentren und öffentliche Einrichtungen'
      },
      a4: {
        title: 'Energieversorger',
        desc: 'Sekundärverteilung in Ringkabelnetzen der Stadtwerke und Netzbetreiber'
      },
      a5: {
        title: 'Erneuerbare Energien',
        desc: 'Netzanbindung und Verteilung für Solar- und Windenergieprojekte'
      },
      a6: {
        title: 'Transport & Verkehr',
        desc: 'Stromversorgung für Bahnhöfe, U-Bahn-Systeme und Flughäfen'
      }
    },
    specs: {
      title: 'Technische Spezifikationen',
      subtitle: 'Leistungsstarke Parameter für höchste Anforderungen',
      electrical: {
        title: 'Elektrische Daten',
        voltage: 'Nennspannung',
        voltage_val: 'bis 24 kV',
        current: 'Nennstrom',
        current_val: 'bis 630 A',
        shortCircuit: 'Kurzschlussfestigkeit',
        shortCircuit_val: 'bis 20 kA',
        insulation: 'Isolationsmedium',
        insulation_val: 'Reine Luft (SF6-frei)'
      },
      environmental: {
        title: 'Umweltdaten',
        gwp: 'Treibhauspotenzial (GWP)',
        gwp_val: '1 (Luft)',
        temp: 'Betriebstemperatur',
        temp_val: '-5°C bis +40°C',
        protection: 'Schutzart',
        protection_val: 'IP2X / IP3X',
        altitude: 'Max. Betriebshöhe',
        altitude_val: 'bis 1000 m ü.NN'
      },
      mechanical: {
        title: 'Mechanische Daten',
        dimensions: 'Bauform',
        dimensions_val: 'Kompakt / Erweiterbar',
        installation: 'Installation',
        installation_val: 'Innenaufstellung',
        lifespan: 'Lebensdauer',
        lifespan_val: '> 30 Jahre',
        maintenance: 'Wartung',
        maintenance_val: 'Wartungsarm'
      }
    },
    features: {
      title: 'Digitale Features',
      f1: {
        title: 'EcoStruxure™ Ready',
        desc: 'Vollständig kompatibel mit der EcoStruxure™ Plattform für IoT-basiertes Energiemanagement'
      },
      f2: {
        title: 'Intelligente Überwachung',
        desc: 'Optional mit Sensoren und Messgeräten für Zustandsüberwachung und Lastmanagement'
      },
      f3: {
        title: 'Digitale Services',
        desc: 'Cloudbasierte Analysedienste für vorausschauende Wartung und Betriebsoptimierung'
      },
      f4: {
        title: 'Fernzugriff',
        desc: 'Sichere Ferndiagnose und -konfiguration für maximale Verfügbarkeit'
      }
    },
    cta: {
      title: 'Die Zukunft der Energieverteilung ist SF6-frei',
      desc: 'RM AirSeT™ vereint bewährte Schaltanlagentechnik mit umweltfreundlicher Innovation. Kontaktieren Sie uns für eine individuelle Beratung zu Ihrer nachhaltigen Mittelspannungslösung.',
      btn1: 'Beratung anfragen',
      btn2: 'Produktdatenblatt laden'
    }
  }
};
export default de;
